import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { storageKeys } from '@/app/constants/storageKeys';
import { authService } from '@/app/services/authService';
import { storage } from '@/app/storage';
import { isTokenExpired } from '@/app/utils/auth/isTokenExpired';
import { decode } from '@/app/utils/auth/jwt';
import { redirectToAuth } from '@/app/utils/auth/redirect';

type RequestRetryCallBack = (token: string) => void;

let isRefreshing = false;
let subscribers: RequestRetryCallBack[] = [];

function subscribeTokenRefresh(cb: RequestRetryCallBack) {
  subscribers.push(cb);
}

function onRefreshed(token: string) {
  subscribers.map((cb) => cb(token));
  subscribers = [];
}

const logoutUser = () => location.assign('/logout');

function tryToRefreshToken(client: AxiosInstance, requestToRetry?: AxiosRequestConfig) {
  const refreshToken: string = storage.get(storageKeys.REFRESH_TOKEN);
  const decodedRefreshToken = decode(refreshToken);

  if (isTokenExpired(decodedRefreshToken?.exp)) {
    redirectToAuth();
    return Promise.reject({ status: 401, message: 'Necessária a reautenticação.' });
  }

  if (!isRefreshing) {
    isRefreshing = true;

    authService
      .refreshToken(refreshToken)
      .then((response) => {
        storage.add(storageKeys.ACCESS_TOKEN, response.accessToken);
        storage.add(storageKeys.REFRESH_TOKEN, response.refreshToken);

        onRefreshed(response.accessToken);
        isRefreshing = false;
      })
      .catch(logoutUser);
  }

  const requestSubscribers = new Promise((resolve) => {
    subscribeTokenRefresh((token) => {
      if (requestToRetry) {
        requestToRetry.headers = { ...requestToRetry.headers, Authorization: `Bearer ${token}` };
        resolve(client(requestToRetry));
      }
    });
  });

  return requestSubscribers;
}

export { tryToRefreshToken };
